import { Loader2 } from "lucide-react";
import { Navigate, Outlet } from "react-router";
import { AccountUnavailable } from "@/components/account-unavailable";
import { useSessionState } from "@/hooks/use-session-state.ts";

export function ProtectedRoute() {
	const status = useSessionState();

	switch (status) {
		case "anonymous":
			return <Navigate to="/login" replace />;
		case "loading":
			return (
				<div className="route-loading">
					<Loader2 />
				</div>
			);
		case "onboarding":
			return <Navigate to="/onboarding" replace />;
		case "orphan":
			return <AccountUnavailable />;
		default:
			return <Outlet />;
	}
}
